let currentId = 0;
export const createId = () => currentId++;
